import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import DEVICES from '../../common/styles/devices';

const Container = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${FONT_FAMILY.hellix.regular};
  flex-direction: column;
  align-items: center;
  &.add-padding{
    padding: 20px 0px 40px 0px;
  }
  &.add-padding-card{
    padding: 20px;
    padding-top: 0px;
  }
  @media only screen and (max-width: 650px) {
    &.add-padding-card{
      padding: 15px;
      padding-top: 0px;
    }
  }
  .main-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 700px;

    @media only screen and (max-width: 650px) {
      width: 100%;
    }
  }
  }

  .inside-div{
    display:flex;
    width: 100%;
    justify-content:space-between;
    margin-top: 20px;
    div:last-child{
      display:flex;
      flex:1;
      justify-content:flex-end;
    }
  }

  .center {
    width: 350px;
    .inside-div {
      display: flex;
      padding-left: 10px;
    }
  }
}
`;

const Header = styled.div`
  text-align: center;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '28px')};
  color: ${COLORS.black};
  padding-top: ${({ $paddingTop }) => ($paddingTop ? $paddingTop : '10px')};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '0px')};
  padding-right: ${({ paddingRight }) => (paddingRight ? paddingRight : '0px')};
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? paddingBottom : '0px')};
  &.flex-space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const CardContainer = styled.div`
  height: 90px;
  max-width: 650px;
  border: 1px solid #e8e8e8;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '50px')};
  border-radius: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  div#addCard {
    cursor: pointer;
  }
  &.saved-cards {
    padding: 20px;
    height: fit-content;
    @media only screen and (max-width: 650px) {
      padding: 15px;
      width: 100%;
    }
  }
  @media only screen and (max-width: 650px) {
    width: 95%;
  }
`;

const AddCardContainer = styled.div`
  width: 412px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  margin-top: 30px;
  overflow: hidden;
  @media only screen and (max-width: 650px) {
    width: 95%;
    &.full-width {
      width: 100%;
    }
  }
`;

const AddCardHeader = styled.div`
  height: fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  cursor: pointer;
  @media only screen and (max-width: 650px) {
    padding: 15px;
  }
`;

const ADD_ICON_IMAGE = styled.img`
  cursor: pointer;
  padding-left: ${(p) => p.$padding || '25px'};
  ${(props) => props.style}
  /* on payment method page z-index of dropdown overrides this*/
  z-index: 10;
`;

const ACC_IMAGE = styled.div`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  box-shadow: inset 1px 0px 7px 0.448718px rgba(0, 0, 0, 0.1);
  img {
    width: 80%;
  }
  @media only screen and (max-width: 650px) {
    height: 50px;
    width: 50px;
    margin-left: 10px;
  }
`;

const ADD_CARD_TEXT = styled.div`
  color: ${({ $isMaxLimitReached }) => ($isMaxLimitReached === true ? '#96a4b9' : '#000000')};
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  letter-spacing: 0.13px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  ${(props) => props.style}
  .title {
    color: ${COLORS.black};
    text-transform: none;
  }
  .title::first-letter {
    text-transform: uppercase;
  }
`;

const CARD_LIMIT_TEXT = styled.div`
  color: ${(props) => (props.disabled ? '#96a4b9' : '#000000')};
  font-size: 12px;
  font-family: ${FONT_FAMILY.hellix.regular};
  letter-spacing: 0;
  margin-left: auto;
  @media only screen and (max-width: 650px) {
    margin-left: 0;
    margin-top: 5px;
  }
`;

const ADD_NEW_CARD_MODAL = styled.div`
  width: 100%;
  background-color: ${COLORS.white};
  height: ${(props) => (props.$showCard ? props.height : '0px')};
  opacity: ${(props) => (props.$showCard ? '1' : '0')};
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  .add-card-form {
    width: 100%;
  }
  @media only screen and (max-width: 370px) {
    height: ${(props) => (props.$showCard ? 'fit-content' : '0px')} !important;
  }
  @media ${DEVICES.mobileXL} {
    height: ${(props) => (props.$showCard ? 'fit-content' : '0px')} !important;
  }
  @media ${DEVICES.mobileL} {
    height: ${(props) => (props.$showCard ? 'fit-content' : '0px')} !important;
  }
`;

const CloseImage = styled.div`
  display: flex;
  justify-content: flex-end;
  ${(props) => props.style}
  .close {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
    @media only screen and (max-width: 650px) {
      width: 350px;
      margin: 0px;
    }
  }
`;

const FieldContainer = styled.div`
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '30px')};
  display: flex;
  &.fixed-height > div {
    height: 75px;
  }
  &.fixed-height_kyc > div {
    height: 100px;
  }
  &.add-spacing > div:first-child {
    margin-right: 15px;
  }
  @media ${DEVICES.mobileXL} {
    display: block;
    &.add-spacing > div:first-child {
      margin-right: 0px;
    }
    &.fixed-height > div {
      height: 65px;
    }
    &.fixed-height_kyc > div {
      height: 90px;
    }
  }
  ${(props) => props.style}

  .field {
    width: 100%;
  }
  .KYC_text {
    text-align: left;
    padding-left: 10px;
    margin-top: 15px;
    font-size: 12px;
  }
`;

const Button = styled.button`
  width: 315px;
  height: 50px;
  background: ${COLORS.brandSecondary};
  border-radius: 4px;
  border: none;
  cursor: pointer;
  ${(p) =>
    p.isLoading &&
    `
      background-color: #A9A9A9;
      cursor: not-allowed;
   `}
  >span {
    font-size: 20px;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 0.71px;
    text-align: center;
    color: ${(p) => (p.isSbm ? '#FFF' : '#000')};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '0px')};

  @media only screen and (max-width: 1024px) {
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '0px')};
    padding-right: ${({ paddingRight }) => (paddingRight ? paddingRight : '0px')};
  }
`;

const NOTES = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
  text-align: center;
  width: 100%;
  &.add-margin {
    margin-top: 30px;
  }
  &.maxlimit-note {
    font-size: 14px;
    margin-top: 10px;
    color: ${COLORS.disabledTextColor};
    width: 412px;
  }
  ${(props) => props.style}
  @media only screen and (max-width: 600px) {
    ${(p) =>
      p.leftAlign &&
      `
    text-align: left;
    `}
    &,&.maxlimit-note {
      width: 95%;
    }
  }
`;

const DELETE_CARD_MODAL = styled.div`
  width: 525px;
  padding-bottom: 35px;
  object-fit: contain;
  border-radius: 8px;
  background-color: ${COLORS.white};

  .text-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-left: 100px;
    padding-right: 100px;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 25px;

    @media only screen and (max-width: 1024px) {
      padding-left: 50px;
      padding-right: 50px;
    }
  }

  .close-text {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    button {
      text-decoration: underline;
      color: ${COLORS.brandPrimary};
      text-decoration-color: ${COLORS.brandPrimary};
      cursor: pointer;
      outline: none;
      border: none;
      background-color: inherit;
    }
  }
`;

const TabularMenu = styled.div`
  padding-top: 4%;
  display: flex;
  margin-bottom: 27px;
  margin-top: 27px;
  border: none !important;
`;

const TabItemWrapper = styled.div`
  margin: 0 10px;
  border: ${(props) => (props.$active ? '2px solid #48f9fe' : '1px solid #f0f0f0')};
  color: rgba(0, 0, 0, 0.87);
  border-radius: 2px;
`;

const TabItem = styled.div`
  padding: 10px;
  cursor: pointer;
  .title {
    font-weight: ${(props) => (props.$active ? '700' : '500')} !important;
    font-family: ${FONT_FAMILY.hellix.regular};
    letter-spacing: 0.12px;
    color: ${COLORS.black};
    margin-bottom: 2px;
  }
`;

const SavedCardListWrapper = styled.div`
  width: 412px;
  @media only screen and (max-width: 600px) {
    width: 95%;
  }
`;

const ModalButton = styled.button`
  background: ${COLORS.brandPrimary} !important;
  color: ${COLORS.white} !important;
  border-radius: 4px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  height: 46px !important;
  width: 307px !important;
  border: none;
  cursor: pointer;
`;

const CardNumberContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100% !important;
  .card_number {
    flex: ${(props) => (props.$showNetwork ? 3 : 1)};
    width: 365px;
    max-width: ${(props) => (props.$showNetwork ? '240px' : '365px')};
  }
  .network-dropdown {
    flex: ${(props) => (props.$showNetwork ? 1 : 0)};
    max-width: ${(props) => (props.$showNetwork ? '160px' : '0')};
    visibility: ${(props) => (props.$showNetwork ? 'visible' : 'hidden')};
    margin-top: -16px;
    .divider.text {
      font-size: 0 !important;
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      justify-content: center;
    }
    .divider.text img {
      font-size: initial;
      width: 100%;
      height: auto;
      top: 2px;
    }
    .visible.menu.transition {
      .image {
        background-color: transparent !important;
      }
      .text {
        display: none;
      }
    }
    .dropdown-light {
      margin-top: 2%;
    }
    .search {
      caret-color: ${COLORS.white};
    }
  }
  #card-network {
    .visible.menu.transition {
      .item {
        &:hover {
          background: ${COLORS.lightborderBlue} !important;
        }
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    display: block;
    .card_number {
      max-width: 100%;
    }
    .divider.text img {
      font-size: initial;
      height: auto;
      width: auto !important;
    }
    .divider.text {
      font-size: 0 !important;
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      justify-content: start !important;
    }
    .network-dropdown {
      max-width: 100%;
      padding-top: 0;
      .visible.menu.transition {
        .image {
          width: 20% !important;
        }
      }
    }
  }
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLORS.lightGrey};
  padding: 12px 16px;
  border-radius: 8px;
  gap: 12px;
  margin-top: 12px;
`;

const InfoIcon = styled.img`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 21.5px;
  height: 21.5px;
  margin-bottom: 12px;
`;

const InfoText = styled.p`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${COLORS.textGrey};
`;

export {
  Container,
  Header,
  CardContainer,
  ADD_ICON_IMAGE,
  ADD_CARD_TEXT,
  CARD_LIMIT_TEXT,
  ADD_NEW_CARD_MODAL,
  CloseImage,
  FieldContainer,
  Button,
  ButtonContainer,
  NOTES,
  DELETE_CARD_MODAL,
  ACC_IMAGE,
  TabItem,
  TabItemWrapper,
  TabularMenu,
  AddCardContainer,
  AddCardHeader,
  SavedCardListWrapper,
  ModalButton,
  CardNumberContainer,
  InfoContainer,
  InfoIcon,
  InfoText
};
